import { atom } from 'nanostores';
// Atom for tracking whether video is in fullscreen mode
export const $isFullscreenAtom = atom(false);
